import React from "react";
import {
  Box,
  Container,
  Typography,
  Link,
  Divider,
  Grid,
  useTheme,
} from "@mui/material";
import GitHubIcon from "@mui/icons-material/GitHub";
import EmailIcon from "@mui/icons-material/Email";

const Footer = () => {
  const currentYear = new Date().getFullYear();
  const theme = useTheme();

  return (
    <Box
      component="footer"
      sx={{
        mt: "auto",
        py: 4,
        px: 2,
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.primary.contrastText,
        borderTop: 0,
      }}
    >
      <Container maxWidth="lg">
        {/* MetaResearch.se on its own row */}
        <Grid container spacing={3} alignItems="flex-start">
          <Grid item xs={12}>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 2,
                marginBottom: 2,
              }}
            >
              <img
                src="metaresearch_se_cropped.png"
                alt="MetaResearch.se Logo"
                style={{
                  maxHeight: "40px",
                  display: "block",
                  objectFit: "contain",
                }}
              />
            </Box>
            <Typography
              variant="body2"
              color={theme.palette.primary.contrastText}
              paragraph
            >
              A platform for clinical trials transparency and research tools,
              maintained by Gustav Nilsonne's research team at Karolinska
              Institutet.
            </Typography>
          </Grid>
        </Grid>

        {/* Quick Links and Contact & Resources on second row */}
        <Grid container spacing={3} alignItems="flex-start">
          {/* Quick Links */}
          <Grid item xs={12} md={6}>
            <Typography
              variant="h6"
              color={theme.palette.primary.contrastText}
              gutterBottom
            >
              Quick Links
            </Typography>
            <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
              <Link
                href="/nordic-trials-dashboard"
                color={theme.palette.secondary.main}
                underline="hover"
              >
                Nordic Clinical Trials Dashboard
              </Link>
              <Link
                href="/trialscout"
                color={theme.palette.secondary.main}
                underline="hover"
              >
                TrialScout
              </Link>
              {/* <Link href="/research-team" color="#FF876F" underline="hover">
                Research Team
              </Link> */}
            </Box>
          </Grid>

          {/* Contact & Resources */}
          <Grid item xs={12} md={6}>
            <Typography
              variant="h6"
              color={theme.palette.primary.contrastText}
              gutterBottom
            >
              Contact & Resources
            </Typography>
            <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <EmailIcon
                  fontSize="small"
                  sx={{ color: theme.palette.secondary.main }}
                />
                <Link
                  href="mailto:love.ahnstrom@ki.se"
                  color={theme.palette.secondary.main}
                  underline="hover"
                >
                  Contact Us
                </Link>
              </Box>
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <GitHubIcon
                  fontSize="small"
                  sx={{ color: theme.palette.secondary.main }}
                />
                <Link
                  href="https://github.com/lahnstrom/vis-nordic"
                  target="_blank"
                  rel="noopener noreferrer"
                  color={theme.palette.secondary.main}
                  underline="hover"
                >
                  Source Code
                </Link>
              </Box>
              <Link
                href="/privacy-policy"
                color={theme.palette.secondary.main}
                underline="hover"
              >
                Privacy Policy
              </Link>
              {/* <Link
                href="https://doi.org/10.1016/j.jclinepi.2025.111710"
                target="_blank"
                rel="noopener noreferrer"
                color="#FF876F"
                underline="hover"
              >
                Research Article
              </Link> */}
            </Box>
          </Grid>
        </Grid>

        <Divider
          sx={{
            my: 3,
            backgroundColor: theme.palette.primary.contrastText,
            opacity: 0.2,
          }}
        />

        {/* Bottom Section */}
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", sm: "row" },
            justifyContent: "space-between",
            alignItems: { xs: "flex-start", sm: "center" },
            gap: 2,
          }}
        >
          <Typography
            variant="body2"
            color={theme.palette.primary.contrastText}
          >
            © {currentYear} MetaResearch.se. All rights reserved.
          </Typography>
          <Box sx={{ display: "flex", gap: 1 }}>
            <Typography
              variant="body2"
              color={theme.palette.primary.contrastText}
            >
              Maintained by{" "}
              <Link
                href="https://nilsonne.net"
                target="_blank"
                rel="noopener noreferrer"
                color={theme.palette.secondary.main}
                underline="hover"
              >
                Gustav Nilsonne's
              </Link>{" "}
              research team at{" "}
              <Link
                href="https://ki.se"
                target="_blank"
                rel="noopener noreferrer"
                color={theme.palette.secondary.main}
                underline="hover"
              >
                Karolinska Institutet
              </Link>
            </Typography>
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;
